import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export default function PendingPage() {
  const { session, profile, signOut } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (session && profile?.status === 'approved') {
      navigate('/', { replace: true });
    }
    if (!session) {
      navigate('/login', { replace: true });
    }
  }, [session, profile, navigate]);

  const isRejected = profile?.status === 'rejected';

  const handleSignOut = async () => {
    await signOut();
    navigate('/login', { replace: true });
  };

  return (
    <div className="flex min-h-screen w-full flex-col items-center justify-center bg-background-50 px-6">
      <div className="w-full max-w-lg rounded-xl border border-background-200 bg-background-100 p-8 text-center">
        <span
          className={`mx-auto flex h-16 w-16 items-center justify-center rounded-full ${
            isRejected ? 'bg-accent-100 text-accent-700' : 'bg-primary-100 text-primary-600'
          }`}
        >
          <i className={isRejected ? 'ri-close-circle-line text-3xl' : 'ri-time-line text-3xl'}></i>
        </span>

        <h1 className="mt-6 text-2xl font-bold text-foreground-950">
          {isRejected ? '가입이 승인되지 않았어요' : '운영자 승인을 기다리고 있어요'}
        </h1>

        <p className="mt-3 text-sm leading-relaxed text-foreground-600">
          {isRejected
            ? '자세한 내용은 운영자에게 문의해주세요.'
            : '회원님의 가입 신청을 운영자가 확인하고 있어요. 승인이 완료되면 이 화면이 자동으로 넘어갑니다.'}
        </p>

        {profile && (
          <div className="mt-6 rounded-lg border border-background-200 bg-background-50 px-4 py-3 text-left">
            <div className="flex items-center justify-between text-sm">
              <span className="text-foreground-600">이름</span>
              <span className="font-medium text-foreground-900">{profile.name || '-'}</span>
            </div>
            <div className="mt-2 flex items-center justify-between text-sm">
              <span className="text-foreground-600">이메일</span>
              <span className="font-medium text-foreground-900">{profile.email}</span>
            </div>
            <div className="mt-2 flex items-center justify-between text-sm">
              <span className="text-foreground-600">상태</span>
              <span
                className={`rounded-full px-2.5 py-0.5 text-xs font-semibold ${
                  isRejected
                    ? 'bg-accent-100 text-accent-800'
                    : 'bg-secondary-200 text-secondary-900'
                }`}
              >
                {isRejected ? '승인 거절' : '승인 대기'}
              </span>
            </div>
          </div>
        )}

        <button
          type="button"
          onClick={() => window.location.reload()}
          className="mt-6 inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition hover:bg-primary-600 whitespace-nowrap"
        >
          <i className="ri-refresh-line"></i>
          상태 새로고침
        </button>

        <div className="mt-4">
          <button
            type="button"
            onClick={handleSignOut}
            className="text-sm font-medium text-foreground-600 hover:text-foreground-900"
          >
            로그아웃
          </button>
        </div>
      </div>
    </div>
  );
}